"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMonitoringEnabled = void 0;
exports.isMonitoringEnabled = function () {
    // our Public component lives within Widget's frame, where we don't control global variables,
    // hence there is no __ENABLE_MONITORING__
    return typeof window.__ENABLE_MONITORING__ === 'boolean'
        ? window.__ENABLE_MONITORING__
        : process.env.NODE_ENV === 'production';
};
//# sourceMappingURL=isMonitoringEnabled.js.map